import { useEffect, useState, type PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps extends PropsWithChildren {
  containerId?: string;
}

export function Portal({
  children,
  containerId = 'woof-woof-overlay-root',
}: PortalProps): JSX.Element | null {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    let nextContainer = document.getElementById(containerId);

    if (!nextContainer) {
      nextContainer = document.createElement('div');
      nextContainer.id = containerId;
      document.body.appendChild(nextContainer);
    }

    setContainer(nextContainer);
  }, [containerId]);

  return container ? createPortal(children, container) : null;
}
